export default __webpack_public_path__ + "static/media/witch-icon.b678c4c2.webp";